import { Button } from "@/components/ui/button";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import { CreateAccountState } from "@/hooks/accounts/useCreateAccountStore";
import { t } from "i18next";

interface ContinueFromLastSaveProps {
	store: CreateAccountState;
	onReset: () => void;
}

export const ContinueFromLastSave = ({
	store,
	onReset,
}: ContinueFromLastSaveProps) => {
	const handleContinue = () => {
		store.setIsShoingResetModal(false);
	};

	const handleReset = () => {
		store.setIsShoingResetModal(false);
		onReset();
	};

	return (
		<Dialog
			open={store.isShowingResetModal}
			onOpenChange={store.setIsShoingResetModal}
		>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>
						{t("admin.dialog.continue-from-last-save.title")}
					</DialogTitle>
					<DialogDescription>
						{t("admin.dialog.continue-from-last-save.description")}
					</DialogDescription>
					<DialogFooter className="pt-8">
						<Button variant="outline" onClick={handleReset}>
							{t("admin.button.reset")}
						</Button>
						<Button onClick={handleContinue}>
							{t("admin.button.continue")}
						</Button>
					</DialogFooter>
				</DialogHeader>
			</DialogContent>
		</Dialog>
	);
};
